import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import { getPublicClientApplicationInstance } from 'utils/functions/authentication';
import commonStrings from 'modules/common/strings';
import { contextToPageNameMap } from 'constants/context';

import {
  Wrapper,
  PageName,
  UserInfoWrapper,
  SelectedProfileWrapper,
  SelectedProfileTitle,
  SelectedProfileText,
  UserNameWrapper,
  UserName,
  LogoutPopup,
  Logout,
} from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { context, selectedCompanyProfile } = useSelector(state => ({
    context: state.common.context,
    selectedCompanyProfile: state.common.selectedCompanyProfile,
  }));

  const userNameWrapperRef = useRef(null);
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSelectedCompanyClick = () => {
    navigate('/companies');
  };

  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    setIsLogoutPopupOpen(false);

    getPublicClientApplicationInstance()
      .logoutPopup()
      .then(() => {
        Cookies.remove('apiAuthToken');
        Cookies.remove('azureAuthToken');
        Cookies.remove('nameAuthCookie');
        Cookies.remove('emailAuthCookie');
        document.location.href = '/login';
      });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const pageName = contextToPageNameMap[context];
  const username = Cookies.get('nameAuthCookie') || Cookies.get('emailAuthCookie') || '';

  const selectedCompanyEmail =
    selectedCompanyProfile.name || sessionStorage.getItem('companyNameAuthCookie');

  return (
    <Wrapper>
      <PageName>{pageName}</PageName>
      <UserInfoWrapper>
        {selectedCompanyEmail && (
          <SelectedProfileWrapper onClick={handleSelectedCompanyClick}>
            <SelectedProfileTitle>{commonStrings.header.selectedCompanyEmail}</SelectedProfileTitle>{' '}
            <SelectedProfileText>{selectedCompanyEmail}</SelectedProfileText>
          </SelectedProfileWrapper>
        )}
        <UserNameWrapper ref={userNameWrapperRef}>
          <UserName
            onClick={() => handleUsernameClick()}
          >{`${commonStrings.header.userNameText} ${username}`}</UserName>
          {isLogoutPopupOpen && (
            <LogoutPopup>
              <Logout onClick={() => handleLogoutClick()}>{commonStrings.header.logoutText}</Logout>
            </LogoutPopup>
          )}
        </UserNameWrapper>
      </UserInfoWrapper>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
